"use client"

import { useState, useEffect, useCallback } from "react"
import type { LocationState } from "../types/register"
import { LOCATION_DATA } from "../constants/register"

export const useLocationData = (country: string, state: string) => {
  const [locationState, setLocationState] = useState<LocationState>({
    availableStates: [],
    availableCities: [],
  })

  // Update available states when country changes
  useEffect(() => {
    if (country && LOCATION_DATA[country]) {
      setLocationState((prev) => ({
        ...prev,
        availableStates: LOCATION_DATA[country].states,
        availableCities: [], // Reset cities when country changes
      }))
    } else {
      setLocationState({
        availableStates: [],
        availableCities: [],
      })
    }
  }, [country])

  // Update available cities when state changes
  useEffect(() => {
    if (country && state && LOCATION_DATA[country]?.cities?.[state]) {
      setLocationState((prev) => ({
        ...prev,
        availableCities: LOCATION_DATA[country].cities[state],
      }))
    } else {
      setLocationState((prev) => ({
        ...prev,
        availableCities: [],
      }))
    }
  }, [country, state])

  const resetLocationData = useCallback(() => {
    setLocationState({
      availableStates: [],
      availableCities: [],
    })
  }, [])

  return {
    ...locationState,
    resetLocationData,
  }
}
